export const EXITS_TABLE_NAME_SORT_KEY = 'investedin_name';

export const EXITS_TABLE_HEADERS = [
    { fieldName: 'Startup HQ', keyName: 'location_data', sortKey: 'location_name' },
    { fieldName: 'Primary Industry', keyName: 'primary_industry_data', sortKey: 'primary_industry_name' },
    { fieldName: 'Exit Type', keyName: 'funding_stage_data', sortKey: 'funding_stage_id' },
    { fieldName: 'Exit Date', keyName: 'date_raised', sortKey: 'date_raised' },
    { fieldName: 'Years to Exit', keyName: 'time_to_exit', sortKey: 'time_to_exit' },
    { fieldName: 'Exit Amount', keyName: 'amount', sortKey: 'amount' },
    { fieldName: 'Total Funding', keyName: 'total_amount_raised_data', sortKey: 'investedin_total_funding' },
    { fieldName: 'Total Deal Count', keyName: 'investedin_funding_count', sortKey: 'investedin_funding_count' },
    { fieldName: 'Acquirer', keyName: 'investors_data', sortKey: 'investor_count' },
    { fieldName: 'Acquirer Type', keyName: 'acquirer_type', sortKey: 'acquirer_type' },
    { fieldName: 'Acquirer Country', keyName: 'acquirer_hq_data', sortKey: 'acquirer_hq_name' },
];
